/**
 * @returns a formatted local timestring of the current time of day
 */
export const getTimeFormatted = (date: Date = new Date()): string | undefined => {
  if (date instanceof Date && !isNaN(date.getTime())) {
    return `${('0' + date.getHours()).slice(-2)}:${('0' + date.getMinutes()).slice(-2)}`;
  }
  return;
};

export default getTimeFormatted;
